
namespace GeniuzPOS.SalePromoCamp {

    @Serenity.Decorators.registerClass()
    export class PromoDayGrid extends Serenity.EntityGrid<PromoDayRow, any> {
        protected getColumnsKey() { return PromoDayColumns.columnsKey; }
        protected getDialogType() { return PromoDayDialog; }
        protected getIdProperty() { return PromoDayRow.idProperty; }
        protected getInsertPermission() { return PromoDayRow.insertPermission; }
        protected getLocalTextPrefix() { return PromoDayRow.localTextPrefix; }
        protected getService() { return PromoDayService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}